import Axios from './axios';
import IContext from './i-context';

export default interface IApiCommon {
}

export default class ApiRequest implements IApiCommon {

    private context: IContext;
    private http: Axios;

    public constructor(context: IContext) {
        this.context = context
        this.http = new Axios(this.context)
    }
    //获取机构数
    public async getOrganization() {
        var result = await this.http.get("/kebai-auth-sys/V1/organization/tree")
        return result
    }
    //获取当前机构信息
    public async selectByOrganizationCode(data:any) {
        var result = await this.http.get("/kebai-auth-sys/V1/organization/selectByOrganizationCode",{...data})
        return result
    } 
    // public async (params:any) {
    //     var data = await this.http.get("",params)
    //     return data
    // }

}